import { render, staticRenderFns } from "./CommentModule.vue?vue&type=template&id=7b3bc1fc&scoped=true"
import script from "./CommentModule.vue?vue&type=script&lang=js"
export * from "./CommentModule.vue?vue&type=script&lang=js"
import style0 from "./CommentModule.vue?vue&type=style&index=0&id=7b3bc1fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3bc1fc",
  null
  
)

export default component.exports